import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { Layer, LayerGroup } from "../types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { GreenGreyBeltLayerType } from "../layer_types/GreenGreyBeltLayerType/GreenGreyBeltLayerType";

export const GREY_BELT: Layer = {
  id: ConstraintsCategory.GREY_BELT,
  layerType: ConstraintsLayerType,
  title: "Greybelt favourability",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  group: LayerGroup.STRATEGIC,
  icon: "lt-leaf-line",
  description: "Unique opportunities for development",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    intersectionThresholdMeters: -1,
    rootCategory: ConstraintsCategory.GREY_BELT,
    categorySchema: [
      { key: "grey_belt_land_more_favourable" },
      { key: "grey_belt_land_average_favourability" },
      { key: "grey_belt_land_less_favourable" },
    ],
  },
};
export const DECLASSIFIED_GREEN_BELT: Layer = {
  id: ConstraintsCategory.DECLASSIFIED_GREEN_BELT,
  layerType: ConstraintsLayerType,
  title: "Declassified greenbelt",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-leaf-line",
  description: "Suitable for development",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    intersectionThresholdMeters: -1,
    rootCategory: ConstraintsCategory.DECLASSIFIED_GREEN_BELT,
    categorySchema: [{ key: "declassified_green_belt" }],
  },
};

// There is currently no green belt layer, creating a temp layer to combine a summary of green and grey belt.
// <3 JN & ST!
export const GREY_SUMMARY: Layer = {
  id: `${ConstraintsCategory.GREY_BELT}_summary`,
  layerType: GreenGreyBeltLayerType,
  title: "Grey belt",
  requiredFeatureAccess: [Feature.insightsSummary, Feature.planningPolicyLayer],
  toggleable: true,
  description:
    "This dataset is from multiple sources showing housing delivery test, 5 year land supply and status of emerging plans.",
  hideByDefault: true,
};
